import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  align-items: center;
  max-width: 100%;
  overflow-x: hidden;

  .ant-select {
    width: 200px;
    min-width: 180px;
    max-width: 100%;
    flex: 1 1 180px;

    .ant-select-selector {
      box-sizing: border-box;
      min-height: 32px;
    }

    .ant-select-selection-item,
    .ant-select-selection-item-content,
    .ant-select-selection-placeholder {
      max-width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    &.ant-select-multiple .ant-select-selection-overflow {
      flex-wrap: nowrap;
      max-width: 100%;
      overflow: hidden;

      .ant-select-selection-overflow-item {
        max-width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
`;

export const TransparentSelectWrapper = styled.div`
  .ant-select-selector,
  .ant-picker {
    box-sizing: border-box;
    border-radius: 4px;
    background-color: ${({ theme }) => theme.colors.white} !important;
  }

  .ant-select-selector {
    border: 1px solid ${({ theme }) => theme.colors.black4};
    min-height: 32px;

    .ant-select-selection-item,
    .ant-select-selection-placeholder,
    .ant-select-selection-item-content {
      color: ${({ theme }) => theme.colors.black8};
    }
  }

  .ant-select-selection-item {
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const CenteredCheckbox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;
